import createReducer from '../createReducer';
import { FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS } from '../../actions/subregion';
import { LEAVE_SPOT_ROUTE } from '../../actions/routes';

const initialState = null;

const handlers = {};

handlers[FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS] = (state, { subregionId }) => subregionId;

handlers[LEAVE_SPOT_ROUTE] = () => initialState;

export default createReducer(handlers, initialState);
